export class OperationQueue {
    tail = Promise.resolve();
    _isFinalPending = false;
    get isFinalPending() {
        return this._isFinalPending;
    }
    enqueue(fn, options) {
        if (this._isFinalPending) {
            return Promise.resolve(undefined);
        }
        let resolve;
        let reject;
        const promise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });
        this.tail = this.tail.then(async () => {
            try {
                const result = options?.timeout
                    ? await withTimeout(fn(), options.timeout)
                    : await fn();
                resolve(result);
            }
            catch (error) {
                reject(error);
            }
        });
        return promise;
    }
    enqueueFinal(fn) {
        this._isFinalPending = true;
        let resolve;
        let reject;
        const promise = new Promise((res, rej) => {
            resolve = res;
            reject = rej;
        });
        this.tail = this.tail.then(async () => {
            try {
                const result = await fn();
                resolve(result);
            }
            catch (error) {
                reject(error);
            }
            finally {
                this._isFinalPending = false;
            }
        });
        return promise;
    }
    reset() {
        this.tail = Promise.resolve();
        this._isFinalPending = false;
    }
}
function withTimeout(promise, ms) {
    return new Promise((resolve, reject) => {
        const timer = setTimeout(() => reject(new Error(`Operation timed out after ${ms}ms`)), ms);
        promise.then((val) => { clearTimeout(timer); resolve(val); }, (err) => { clearTimeout(timer); reject(err); });
    });
}
